import React from 'react'
import {
  BE_SAFERPAY_MULTIPLE_WALLETS,
  BE_SAFERPAY_AMEX,
  BE_SAFERPAY_APPLE_PAY,
  BE_SAFERPAY_GOOGLE_PAY
} from './paymentTypesEnum'
import { PaymentPageIcons } from 'Rentlio/components/UI/PaymentPageIcons/style'
import ApplePayIcon from 'Rentlio/components/Icons/applePay'
import GooglePayIcon from 'Rentlio/components/Icons/googlePay'
import Amex from 'Rentlio/components/Icons/amex'

const GOOGLE_PAY_KEY = 'googlepay'
const APPLE_PAY_KEY = 'applepay'
const AMEX_KEY = 'amex'

const hasAmexEnabled = cardTypes => {
  return cardTypes?.split(',').some(type => type === AMEX_KEY)
}

const getOptionId = option => {
  if (option === AMEX_KEY) {
    return BE_SAFERPAY_AMEX
  }
  if (option === GOOGLE_PAY_KEY) {
    return BE_SAFERPAY_GOOGLE_PAY
  }
  if (option === APPLE_PAY_KEY) {
    return BE_SAFERPAY_APPLE_PAY
  }
}

export const SaferpayPaymentPageEnum = {
  [GOOGLE_PAY_KEY]: {
    value: GOOGLE_PAY_KEY,
    label: 'google pay',
    id: GOOGLE_PAY_KEY,
    icon: <GooglePayIcon />
  },
  [APPLE_PAY_KEY]: {
    value: APPLE_PAY_KEY,
    label: 'apple pay',
    id: APPLE_PAY_KEY,
    icon: <ApplePayIcon />
  },
  [AMEX_KEY]: {
    value: AMEX_KEY,
    label: 'amex',
    id: AMEX_KEY,
    icon: <Amex />
  }
}

export const getOtherPaymentOptions = saferpayMethod => {
  const otherOptions = []

  const hasAmex = hasAmexEnabled(saferpayMethod?.settings?.selectedCardTypes)

  if (
    (saferpayMethod?.settings?.selectedWalletTypes &&
      saferpayMethod?.settings?.selectedWalletTypes?.split(',')?.length > 0) ||
    hasAmex
  ) {
    let wallets = saferpayMethod?.settings?.selectedWalletTypes?.split(',').filter(Boolean) || []

    // AMEX does not support forcing 3DS through the API method we use, so 3DS would not
    // necessarily be triggered for guests. As a result, the tokenized card cannot be charged by
    // the user because the MIT transaction would be declined. The workaround is to use
    // their Payment Page or Transaction Interface with a certain amount to force 3DS.
    // It was easier for us to simply add the Payment Page here.
    if (hasAmex) {
      wallets.push(AMEX_KEY)
    }

    if (wallets.includes(GOOGLE_PAY_KEY) && wallets.includes(APPLE_PAY_KEY)) {
      // remove them from array to avoid duplication
      wallets = wallets.filter(item => item !== GOOGLE_PAY_KEY && item !== APPLE_PAY_KEY)

      const googlePay = SaferpayPaymentPageEnum[GOOGLE_PAY_KEY]
      const applePay = SaferpayPaymentPageEnum[APPLE_PAY_KEY]

      otherOptions.push({
        bookingEngineId: saferpayMethod.bookingEngineId,
        paymentPageOption: `${GOOGLE_PAY_KEY},${APPLE_PAY_KEY}`,
        component: (
          <PaymentPageIcons>
            {googlePay.icon}
            {applePay.icon}
          </PaymentPageIcons>
        ),
        id: BE_SAFERPAY_MULTIPLE_WALLETS
      })
    }

    wallets.forEach(item => {
      const paymentPageOption = SaferpayPaymentPageEnum[item]

      if (!paymentPageOption) {
        return
      }

      otherOptions.push({
        bookingEngineId: saferpayMethod.bookingEngineId,
        paymentPageOption: item,
        id: getOptionId(item),
        component: <PaymentPageIcons>{paymentPageOption.icon}</PaymentPageIcons>
      })
    })
  }

  return otherOptions
}

export const getPaymentPageWalletsArray = selectedPaymentMethod => {
  switch (selectedPaymentMethod) {
    case BE_SAFERPAY_MULTIPLE_WALLETS:
      return ['GOOGLEPAY', 'APPLEPAY']
    case BE_SAFERPAY_GOOGLE_PAY:
      return ['GOOGLEPAY']
    case BE_SAFERPAY_APPLE_PAY:
      return ['APPLEPAY']
    default:
      return []
  }
}

export const getPaymentPageMethodsArray = selectedPaymentMethod => {
  switch (selectedPaymentMethod) {
    case BE_SAFERPAY_AMEX:
      return ['AMEX']
    default:
      return []
  }
}
